<app-table [config]="config" />
